import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt";

document.addEventListener("turbolinks:load", function (_event) {
  flatpickr(".date-picker", {
    locale: Portuguese,
    dateFormat: "d/m/Y",
  });
});
